module.exports = __webpack_public_path__ + "files/yellow.259d4656dc366d6ff964afdb5894dbe2.png";